define('uikit/extra/static.methods',['require','exports','module','underscore'],function(require, exports, module) {
  var _ = require('underscore');


  var StaticMethods = {
    extendInternalViewOptions: function (obj) {
      var parent = this.prototype.internalViewOptions;

      // perform deep copy of the object
      var copy = _.extend({}, parent);

      // for each child option
      _.each (obj, function (value, key)
      {
        // if parent options also have the child option
        if (_.has(parent, key))
        {

          // create a copy of old value
          var childValue = value;
          var parentValue = parent[key];

            //function that will execute when internalViewOptions are resolved (on initialize of the views)
            value = (function(parentValue, childValue) {
              return function () {
              // merge values of the parent into child values
                return _.extend({}, Mn._getValue(parentValue, this), Mn._getValue(childValue, this) );
              }
            })(parentValue, childValue)
        }

        // save new value
        copy[key] = value;
      });

      return copy;
    }
  }
  module.exports = StaticMethods;

});

